module.exports = __webpack_public_path__ + "static/media/simResult.781b5133.png";